export default __webpack_public_path__ + "static/media/IMG_0051_8_11zon.3fcc3601.jpg";